import request from '@/utils/request';
// 保存实体菜单
export function addMenu(data) {
  return request({
    url: '/malldecoration/channel-category/add-category',
    method: 'post',
    data: data
  });
}
// 删除菜单
export function deleteMenu(data) {
  return request({
    url: '/malldecoration/channel-category/remove-category',
    method: 'post',
    data: data
  });
}
// 获取城市
export function getCityList(params) {
  return request({
    url: '/malldecoration/category-region/region',
    method: 'get',
    params: params
  });
}
// 获取编辑数据
export function getCategoryData(params) {
  return request({
    url: '/malldecoration/channel-category/get-category-data',
    method: 'get',
    params: params
  });
}
// 保存编辑
export function updateMenu(data) {
  return request({
    url: '/malldecoration/channel-category/update-category',
    method: 'post',
    data: data
  });
}
// 获取已选商品
export function getSelectGoodsList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-select-goods-list',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 获取待选商品
export function getWaitingGoodsList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-waiting-goods-list',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 选中移除
export function removeByChecked(data) {
  return request({
    url: '/malldecoration/channel-category-goods/remove-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 选中添加
export function addByChecked(data) {
  return request({
    url: '/malldecoration/channel-category-goods/add-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 条件添加
export function addByCondition(data) {
  return request({
    url: '/malldecoration/channel-category-goods/add-by-condition',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取渠道供应商
export function getSupplierList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-supplier-list',
    method: 'get',
    params: params
  });
}
// 获取快递公司列表
export function getExpressList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-express-list',
    method: 'get',
    params: params
  });
}
// 获取商品分类
export function getCatList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/cat-list',
    method: 'get',
    params: params
  });
}
// 按条件删除
export function removeByCondition(data) {
  return request({
    url: '/malldecoration/channel-category-goods/remove-by-condition',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取商品分类
export function getBrandList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-brand',
    method: 'get',
    params: params
  });
}
// 按选中调价
export function adjustByChecked(data) {
  return request({
    url: '/malldecoration/channel-category-adjust/adjust-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 按条件调价
export function adjustByCondition(data) {
  return request({
    url: '/malldecoration/channel-category-adjust/adjust-by-condition',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 修改价格
export function adjustByPrice(data) {
  return request({
    url: '/malldecoration/channel-category-goods/hand-adjust',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取搜索条件
export function getSearchList(params) {
  return request({
    url: '/orders/settlement-manage/search-types',
    method: 'get',
    params: params
  });
}
// 获取订单列表
export function getOrderList(params) {
  return request({
    url: '/orders/settlement-manage/list',
    method: 'get',
    params: params
  });
}
// 获取订单导出
export function exportOrders(params) {
  return request({
    url: '/orders/settlement-manage/export',
    method: 'get',
    params: params
  });
}
// 订单保存结算状态接口
export function orderUpdateSettlementStatus(data) {
  return request({
    url: '/orders/settlement-manage/update-settlement-status',
    method: 'post',
    data: data
  });
}
// 2级菜单
export function getCustomCatList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-custom-cat-list',
    method: 'get',
    params: params
  });
}
// 删除2级菜单
export function delCustomCatList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/remove-custom-cat',
    method: 'get',
    params: params
  });
}
// 添加2级菜单
export function addCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/add-custom-cat',
    method: 'post',
    data: data
  });
}
// 编辑2级菜单
export function updateCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/update-custom-cat',
    method: 'post',
    data: data
  });
}
// 获取编辑2级菜单
export function getSecondaryCustomCatData(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-custom-cat-data',
    method: 'get',
    params: params
  });
}
// 获取2级已选商品
export function getSecondarySelectGoodsList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/get-select-goods-list',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 获取2级待选商品
export function getSecondaryWaitingGoodsList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/get-waiting-goods-list',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 2级选中移除
export function removeSecondaryByChecked(data) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/remove-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 2级条件移除
export function removeSecondaryByCondition(params) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/remove-by-condition',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 2级选中添加
export function addSecondaryByChecked(data) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/add-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 2级条件添加
export function addSecondaryByCondition(params) {
  return request({
    url: '/malldecoration/channel-custom-cat-goods/add-by-condition',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 默认排序
export function updateDefaultSort(data) {
  return request({
    url: '/malldecoration/channel-category-goods/update-sort-init',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 选中排序
export function updateByCheckedSort(data) {
  return request({
    url: '/malldecoration/channel-category-goods/update-by-checked-sort',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 条件排序
export function updateByConditionSort(data) {
  return request({
    url: '/malldecoration/channel-category-goods/update-by-condition-sort',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 销售后备商品列表
export function getSaleReserveGoods(params) {
  return request({
    url: '/package/reserve-goods/goods-list',
    method: 'get',
    params: params
  });
}
// 订单详情
export function getShopOrdersDetail(params, source) {
  return request({
    url: source == 'userOrder' ? '/orders/voucher-order/shop-order-detail' : '/orders/shop-orders/detail',
    method: 'get',
    params: params
  });
}
// 查看取票手机号
export function watchMovieUserMobile(params) {
  return request({
    url: '/orders/shop-orders/movie-user-mobile',
    method: 'get',
    params: params
  });
}
// 查看订单手机号
export function watchMovieOrderMobile(params) {
  return request({
    url: '/orders/shop-orders/movie-order-mobile',
    method: 'get',
    params: params
  });
}
// 查看取票码
export function watchMovieVerCode(params) {
  return request({
    url: '/orders/shop-orders/movie-vercode',
    method: 'get',
    params: params
  });
}
// 获取渠道个性化菜单
export function getCategoryList(params) {
  return request({
    url: '/malldecoration/category-region/category-list',
    method: 'get',
    params: params
  });
}
// 导出商品
export function exportCategoryGoods(params) {
  return request({
    url: '/malldecoration/channel-category-goods-download/category-list',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 下载模板
export function downTemp(params, type) {
  var url = '/malldecoration/channel-category-goods-upload/temp';
  if (type === 'remove') {
    url = '/malldecoration/channel-category-goods-upload/remove-temp';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
// 上传
export function uploadTemp(data, type) {
  var url = '/malldecoration/channel-category-goods-upload/upload-file';
  if (type === 'remove') {
    url = '/malldecoration/channel-category-goods-upload/upload-remove';
  }
  return request({
    url: url,
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 导入商品日志
export function getImportGoodsLog(params) {
  return request({
    url: '/malldecoration/channel-category-goods-upload/search-log',
    method: 'get',
    params: params
  });
}
// 复制菜单
export function copyCategory(params) {
  return request({
    url: '/malldecoration/channel-category/copy-category',
    method: 'get',
    params: params
  });
}
// 1级菜单导出待选商品
export function exportCategoryGoods2(params) {
  return request({
    url: '/malldecoration/channel-category-goods-download/s-category-list',
    method: 'get',
    params: params
  });
}
// 2级待选
export function exportSecondCategoryGoods(params) {
  return request({
    url: '/malldecoration/channel-category-goods-download/s-w-c-list',
    method: 'get',
    params: params
  });
}
// 2级已选
export function exportSecondCategoryGoods2(params) {
  return request({
    url: '/malldecoration/channel-category-goods-download/s-s-c-list',
    method: 'get',
    params: params
  });
}
export function getChannelSelection(params) {
  return request({
    url: '/malldecoration/channel-category/channel-selection',
    method: 'get',
    params: params
  });
}
// 设置起购数量
export function uploadMinBuyNumber(data) {
  return request({
    url: '/malldecoration/channel-category-goods/update-min-buy-number',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
export function channelCodeRiskUserExport(params) {
  return request({
    url: '/user/channel-code-risk-user/export',
    method: 'get',
    params: params
  });
}
export function getRiskUser(params) {
  return request({
    url: '/user/channel-code-risk-user/index',
    method: 'get',
    params: params
  });
}
// 线下蛋糕风险门店列表
export function getOffCakeRiskUser(params) {
  return request({
    url: '/user/off-cake-risk-user/index',
    method: 'get',
    params: params
  });
}
// 商城订单风险用户 - 景点门票风险用户 列表
export function getRiskUserTicket(params, module) {
  var url = '/user/channel-ticket-risk-user/index';
  if (module === 'movie') {
    url = '/user/online-movie-risk-user/index';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/index';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/index';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/index';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/index';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/index';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportRiskUser(params, module) {
  var url = '/user/channel-ticket-risk-user/export';
  if (module === 'movie') {
    url = '/user/online-movie-risk-user/export';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/export';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/export';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/export';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/export';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function batchIgnores(data, module) {
  var url = '/user/channel-code-risk-user/ignores';
  if (module === 'code') {
    url = '/user/channel-code-risk-user/ignores';
  } else if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/ignores';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/ignores';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/ignores';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/ignores';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/ignores';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/ignores';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/ignores';
  } else if (module === 'off_cake') {
    url = '/user/off-cake-risk-user/ignores';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 电子卡密风险用户 - 忽略
export function ignore(data, module) {
  var url = '/user/channel-code-risk-user/ignore';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/ignore';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/ignore';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/ignore';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/ignore';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/ignore';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/ignore';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/ignore';
  } else if (module === 'off_cake') {
    url = '/user/off-cake-risk-user/ignore';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 电子卡密风险用户 - 高级设置
export function setting(data, module) {
  var url = '/user/channel-code-risk-user/setting';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/setting';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/setting';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/setting';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/setting';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/setting';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/setting';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/setting';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 电子卡密风险用户 - 拉黑
export function block(data, module, blockType) {
  var url = '/user/channel-code-risk-user/block';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/block';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/block';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/block';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/block';
  } else if (module === 'bind_card') {
    url = blockType === 'user' ? '/user/channel-risk-user/block-user' : '/user/channel-risk-user/block';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/block';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/block';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 电子卡密风险用户 - 操作日志
export function getLog(params, module) {
  var url = '/user/channel-code-risk-user/log';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/log';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/log';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/log';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/log';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/log';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/log';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/log';
  } else if (module === 'off_cake') {
    url = '/user/off-cake-risk-user/log';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
// 按选中项设置促销
export function byCheckedSetPromotion(data) {
  return request({
    url: '/malldecoration/channel-category-goods/promotion-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 按条件项设置促销
export function byConditionSetPromotion(data) {
  return request({
    url: '/malldecoration/channel-category-goods/promotion-by-condition',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 订单风控列表
export function getRiskList(params) {
  return request({
    url: '/orders/order-risk/list',
    method: 'get',
    params: params
  });
}
// 订单客户列表
export function getCustomerList(data) {
  return request({
    url: '/orders/order-risk/customer-list',
    method: 'post',
    data: data
  });
}
// 查看手机号
export function getMobile(params, module) {
  var url = '/user/channel-code-risk-user/get-mobile';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/get-mobile';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/get-mobile';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/get-mobile';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/get-mobile';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/get-mobile';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/get-mobile';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/get-mobile';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function getIgnoreInfo(params, module) {
  var url = '/user/channel-code-risk-user/ignore-view';
  if (module === 'ticket') {
    url = '/user/channel-ticket-risk-user/ignore-view';
  } else if (module === 'movie') {
    url = '/user/online-movie-risk-user/ignore-view';
  } else if (module === 'phone_abnormal') {
    url = '/user/receive-mobile-risk-user/ignore-view';
  } else if (module === 'preform') {
    url = '/user/performance-risk-user/ignore-view';
  } else if (module === 'bind_card') {
    url = '/user/channel-risk-user/ignore-view';
  } else if (module === 'phone_verify') {
    url = '/user/verify-mobile-risk-user/ignore-view';
  } else if (module === 'cake_home') {
    url = '/user/cake-risk-user/ignore-view';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
// 个性化菜单 复制
export function copyCategoryCat(data) {
  return request({
    url: '/malldecoration/channel-category/copy-cate',
    method: 'post',
    data: data
  });
}
// 获取二级菜单
export function getCustomCat(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-custom-cat',
    method: 'get',
    params: params
  });
}
// 二级菜单案选中项保存
export function byCustomCatChecked(data) {
  return request({
    url: '/malldecoration/channel-category-goods/edit-cat-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 二级菜单按条件项保存
export function byCustomCatCondition(data) {
  return request({
    url: '/malldecoration/channel-category-goods/edit-cat-by-condition',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 利润率排序
export function profitSort(data) {
  return request({
    url: '/malldecoration/channel-category-goods/set-sort-by-real-profit',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 下载京东地址模版
export function downProductsTemp(params) {
  return request({
    url: '/products/goods-check/temp',
    method: 'get',
    params: params
  });
}
// 校验京东地址
export function jdCheckAddress(data) {
  return request({
    url: 'products/goods-check/jd-check-address',
    method: 'post',
    data: data
  });
}
// 校验京东地址
export function lockGoods(data) {
  return request({
    url: '/malldecoration/channel-category-goods/lock-goods',
    method: 'post',
    data: data
  });
}
// 添加个性化菜单增加利润率
export function getRateInfo(params) {
  return request({
    url: '/malldecoration/channel-category/get-rate-info',
    method: 'get',
    params: params
  });
}
// 蛋糕到家 或者品牌和分类
export function getPreInfo(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-pre-info',
    method: 'get',
    params: params
  });
}
// 实体规则类型
export function getEntityMoneyTypes(params) {
  return request({
    url: '/products/channel-entity-adjust/money-types',
    method: 'get',
    params: params
  });
}
// 实体规则列表
export function getEntityMoneyAdjustList(data) {
  return request({
    url: '/products/channel-entity-adjust/rules',
    method: 'post',
    data: data
  });
}
// 实体规则列表 -待选客户
export function getEntityMoneyAdjustCustomer(data) {
  return request({
    url: '/products/channel-entity-adjust/customer',
    method: 'post',
    data: data
  });
}
// 实体规则列表 -保存
export function setEntityMoneyAdjust(data) {
  return request({
    url: '/products/channel-entity-adjust/set-rule',
    method: 'post',
    data: data
  });
}
// 实体规则列表 -获取规则
export function getEntityEditAdjust(params) {
  return request({
    url: '/products/channel-entity-adjust/rule',
    method: 'get',
    params: params
  });
}
// 实体规则列表 -删除规则
export function delEntityAdjust(data) {
  return request({
    url: '/products/channel-entity-adjust/del-rule',
    method: 'post',
    data: data
  });
}
// 实体规则列表 - 日志列表
export function getChannelEntityLogList(params) {
  return request({
    url: '/products/channel-entity-adjust/rule-logs',
    method: 'get',
    params: params
  });
}
// 3级菜单
export function getThirdCustomCatList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-custom-cat-list',
    method: 'get',
    params: params
  });
}
// 添加3级菜单
export function addThirdCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/add-custom-cat',
    method: 'post',
    data: data
  });
}
// 编辑3级菜单
export function updateThirdCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/update-custom-cat',
    method: 'post',
    data: data
  });
}
// 获取编辑3级菜单
export function getThirdCustomCatData(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-custom-cat-data',
    method: 'get',
    params: params
  });
}
// 删除3级菜单
export function delThirdCustomCatList(params) {
  return request({
    url: '/malldecoration/channel-custom-cat/remove-custom-cat',
    method: 'get',
    params: params
  });
}
//实体 获取 规则列表 实体菜单
export function getAdjustRuleList(params) {
  return request({
    url: '/malldecoration/channel-category-adjust/get-rule-list',
    method: 'get',
    params: params
  });
}
//实体 恢复未调价模式 - 选中操作
export function checkedUpdateChangeMode(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/update-change-mode-by-checked',
    method: 'post',
    data: data
  });
}
//实体 恢复未调价模式 -按条件操作
export function conditionUpdateChangeMode(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/update-change-mode-condition',
    method: 'post',
    data: data
  });
}
//实体 调价规则列表
export function getCategoryRuleList(params) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/get-rule-list',
    method: 'get',
    params: params
  });
}
//实体 调价规则列表 - 删除
export function delCategoryRuleList(params) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/remove-rule',
    method: 'get',
    params: params
  });
}
//实体 调价规则列表 -商品管理 - 选中移除
export function checkedAdjustRuleRemove(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/remove-by-checked',
    method: 'post',
    data: data
  });
}
//实体 调价规则列表 -商品管理 - 条件移除
export function conditionAdjustRuleRemove(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/remove-by-condition',
    method: 'post',
    data: data
  });
}
//实体 调价规则列表 -商品管理 - 编辑 - 获取数据
export function getAdjustRule(params) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/get-rule',
    method: 'get',
    params: params
  });
}
//实体 调价规则列表 -商品管理 - 编辑 - 保存数据
export function editAdjustRule(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/edit-rule',
    method: 'post',
    data: data
  });
}

/**
 * 商城管理 - 风控管理 - 获取主动识别用户列表
 * @param {*} params
 * @returns
 */
export function getIgnoreLog(params) {
  return request({
    url: '/user/operation-log/identify-log',
    method: 'get',
    params: params
  });
}
// uid登录账号数列表
export function getUidLoginNumList(params) {
  return request({
    url: '/user/operation-log/user-list',
    method: 'get',
    params: params
  });
}
// 绑卡记录列表
export function getBindCardRecordList(params) {
  return request({
    url: '/user/operation-log/card-list',
    method: 'get',
    params: params
  });
}
// 绑卡合作公司清单
export function getBindCardCompanyList(params) {
  return request({
    url: '/user/operation-log/account-list',
    method: 'get',
    params: params
  });
}
// 查看操作日志详情
export function getOperationLogView(params) {
  return request({
    url: '/user/operation-log/view',
    method: 'get',
    params: params
  });
}
// 查看卡详情
export function getOperationLogCardView(params) {
  return request({
    url: '/user/operation-log/card-view',
    method: 'get',
    params: params
  });
}
// 三级菜单下载模板
export function getTemp(params) {
  return request({
    url: '/malldecoration/channel-custom-cat-upload/temp',
    method: 'get',
    params: params
  });
}
// 三级菜单 批量上传
export function uploadCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat-upload/upload-file',
    method: 'post',
    data: data
  });
}
// 获取促销关联菜单
export function getCorrelationCategoryList(params) {
  return request({
    url: '/malldecoration/channel-category/get-correlation-category-list',
    method: 'get',
    params: params
  });
}

// 获取黑名单子菜单设置
export function getBlackList(params) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/black-list',
    method: 'get',
    params: params
  });
}
//蛋糕到家 恢复未调价模式 - 选中操作
export function checkedCakeUpdateChangeMode(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/update-change-mode-by-checked',
    method: 'post',
    data: data
  });
}
//蛋糕到家 恢复未调价模式 -按条件操作
export function conditionCakeUpdateChangeMode(data) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/update-change-mode-condition',
    method: 'post',
    data: data
  });
}
// 昆仑列表
export function getKunLUnList(params) {
  return request({
    url: '/malldecoration/channel-category/get-brand-map',
    method: 'get',
    params: params
  });
}
// 昆仑 菜单
export function getKunLUnCategory(params) {
  return request({
    url: '/malldecoration/channel-category/get-zsy-category',
    method: 'get',
    params: params
  });
}
// 昆仑列表
export function getSearchKunLUnList(params) {
  return request({
    url: '/malldecoration/channel-category/search-zsy-brand',
    method: 'get',
    params: params
  });
}
// 昆仑 选中
export function bindZsyBrand(data) {
  return request({
    url: '/malldecoration/channel-category/bind-zsy-brand',
    method: 'post',
    data: data
  });
}

/**
 * 获取可设置组件列表
 * @param {*} params
 * @returns
 */
export function getWidget(params) {
  return request({
    url: '/malldecoration/channel-category/get-widget',
    method: 'get',
    params: params
  });
}
/**
 * 获取促销菜单装修配置接口
 * @param {*} params
 * @returns
 */
export function getFloorConfig(params) {
  return request({
    url: '/malldecoration/channel-category/get-category-floor-config',
    method: 'get',
    params: params
  });
}
/**
 * 保存促销菜单装修配置接口
 * @param {*} data
 * @returns
 */
export function saveFloorConfig(data) {
  return request({
    url: '/malldecoration/channel-category/save-category-floor-config',
    method: 'post',
    data: data
  });
}
// 获取要批量删除的空的三级菜单接口
export function getAutoDeleteThirdCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/get-auto-delete-third-custom-cat',
    method: 'post',
    data: data
  });
}
// 批量删除空的三级菜单接口
export function delAutoDeleteThirdCustomCat(data) {
  return request({
    url: '/malldecoration/channel-custom-cat/auto-delete-third-custom-cat',
    method: 'post',
    data: data
  });
}
// 资源明细 - 基础信息接口(返回客户列表、4个层级规则)
export function getResourceDetailsBase(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-rule-config',
    method: 'get',
    params: params
  });
}
// 资源明细 - 可见商品列表接口
export function getResourceDetailsList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-goods-count',
    method: 'get',
    params: params,
    timeout: 3 * 60 * 1000
  });
}
// 资源明细 - 商品清单(单品列表)接口 - 弹框
export function getResourceDetailsGoodsList(params) {
  return request({
    url: '/malldecoration/channel-category-goods/get-goods-list',
    method: 'get',
    params: params
  });
}

// 菜单黑名单明细（查看明细弹框）资源明细
export function getChannelCategoryAdjustRuleBlackList(params) {
  return request({
    url: '/malldecoration/channel-category-adjust-rule/black-list',
    method: 'get',
    params: params
  });
}
// 菜单黑名单明细（查看明细弹框） - 导出
export function exportChannelCategoryscdu(params) {
  return request({
    url: '/malldecoration/channel-category-goods-download/s-c-d-u',
    method: 'get',
    params: params
  });
}
// UnionID绑定账号列表
export function getUnionIdBindList(params) {
  return request({
    url: '/user/wechat-risk/index',
    method: 'get',
    params: params
  });
}
// UnionID已绑定账号明细
export function getWechatRiskUserList(params) {
  return request({
    url: '/user/wechat-risk/user-list',
    method: 'get',
    params: params
  });
}
// 登录异常列表
export function getLoginAbnormalList(params) {
  return request({
    url: '/user/wechat-risk/log',
    method: 'get',
    params: params
  });
}